/**
 * 求人詳細関連リンクの項目ラベルテキスト
 */
export const RELATION_LINK_LABEL = {
  OCCUPATION: '職種から探す',
  AREA: '勤務地から探す',
  LOCATION: 'エリアから探す',
  STATION: '最寄り駅から探す',
  INDUSTRY: '業種から探す',
} as const;
